import { createFilterOptions } from '@mui/material/Autocomplete';

export const filter = createFilterOptions();

export const getFilterOptions =
  (loading, freeSolo = true) =>
  (options, params) => {
    const filtered = filter(options, params);

    if (!loading && freeSolo) {
      const { inputValue } = params;
      const isExisting = options.some(option => inputValue === option.label);
      if (inputValue !== '' && !isExisting) {
        filtered.push({
          inputValue,
          label: `Add "${inputValue}"`
        });
      }
    }

    return filtered;
  };

export const getOptionLabel = option => {
  // Value selected with enter, right from the input
  if (typeof option === 'string') {
    return option;
  }
  // Add "xxx" option created dynamically
  if (option.inputValue) {
    return option.inputValue;
  }
  // Regular option
  return option.label;
};

export const ENTER = 'Enter';
